import request from "@/utils/request";
import config from "@/utils/config";

let baseApi = config.env.VUE_APP_BRAND === 'COTTI' ? '/cotti-capi' : '/teacat-capi'

export function invoiceTaskInfo(data) {
    return request({
        url: baseApi + "/invoice/invoiceTaskInfo",
        method: "POST",
        data
    });
}

export function resendEmail(data) {
    return request({
        url: baseApi + "/invoice/resendEmail",
        method: "POST",
        data
    });
}

export function invoiceTaskOrder(data) {
    return request({
        url: baseApi + "/invoice/invoiceTaskOrder",
        method: "POST",
        data
    });
}

export function updateInvoice(data) {
    return request({
        url: baseApi + "/invoice/invoiceTaskUpdate",
        method: "POST",
        data
    });
}
